import type { SubscriberListRef } from '../api/subscribersApi';
import { reasonFor, type MyListActions } from '../hooks/useMyListActions';
import { AddSubscriberDialog } from './AddSubscriberDialog';
import { ImportClientsDialog } from './ImportClientsDialog';
import { ListDialog } from './ListDialog';

type Props = {
  actions: MyListActions;
  current: SubscriberListRef | undefined;
  /** Lists this account may add people to. */
  editable: SubscriberListRef[];
  isAdmin: boolean;
  accountIsAdmin: boolean;
  myName: string;
  fixedOwner?: { id: number; name: string } | undefined;
};

/** Making or renaming a list, adding a person and importing a CSV, whichever is open. */
export function MyListDialogs({ actions: a, current, editable, isAdmin, accountIsAdmin, myName, fixedOwner }: Props) {
  const naming = a.naming;
  const mutation = a.namingMutation;
  return (
    <>
      {naming ? (
        <ListDialog
          mode={naming.kind}
          initial={naming.kind === 'rename' ? { name: naming.name, description: naming.description } : undefined}
          isAdmin={isAdmin}
          accountIsAdmin={accountIsAdmin}
          fixedOwner={fixedOwner}
          myName={myName}
          isPending={mutation.isPending}
          error={mutation.isError ? reasonFor(mutation.error) : null}
          onCancel={a.cancelNaming}
          onSave={a.save}
        />
      ) : null}
      {a.importing && current ? (
        <ImportClientsDialog
          listName={current.name}
          isPending={a.m.importClients.isPending}
          error={a.m.importClients.isError ? reasonFor(a.m.importClients.error) : null}
          result={a.m.importClients.data}
          onCancel={a.closeImport}
          onImport={(csv, optedIn) => { a.importCsv(current.id, csv, optedIn); }}
        />
      ) : null}
      {a.adding ? (
        <AddSubscriberDialog lists={editable} startList={current?.editable ? current.id : ''} isPending={a.m.add.isPending} error={a.addError} onCancel={a.cancelAdd} onAdd={a.add} />
      ) : null}
    </>
  );
}
